export default "__VITE_ASSET__Bck97s_h__"